export default [
    {
        title: "mainmenu.engage",
        route: "engage",
        icon: "bullhorn",
        class: "d-none d-sm-block",
        resource: "engage",
        action: "read",
    },
];
